module.exports = __webpack_public_path__ + "static/media/mobile_fourth_img.d4303403.png";